import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { Avatar } from 'lmcv/components/Avatar'
import { Skeleton } from 'lmcv/components/Skeleton'

import * as S from './styled'

const ProfileSkeleton = () => (
  <Card>
    <S.Content>
      <S.Header>
        <Avatar loading />
      </S.Header>

      <S.TextContainer>
        <Skeleton width="150px" height="20px" /> <br />
        <Skeleton width="80px" height="15px" />
      </S.TextContainer>

      <S.Divider />

      <S.DateContainer>
        <Skeleton width="150px" height="20px" /> <br />
        <Skeleton width="80px" height="15px" />
      </S.DateContainer>
    </S.Content>
  </Card>
)

export default ProfileSkeleton
